import { useEffect, useState } from "react";

export const useDebounce = (value, delay = 500) => {
  const [searchQuery, setSearchQuery] = useState(value);

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      setSearchQuery(value);
    }, delay);

    return () => clearTimeout(searchTimeout);
  }, [value, delay]);

  return searchQuery;
};
